import { render, staticRenderFns } from "./BarOrderPanel.vue?vue&type=template&id=6b7f7efe&scoped=true"
import script from "./BarOrderPanel.vue?vue&type=script&lang=js"
export * from "./BarOrderPanel.vue?vue&type=script&lang=js"
import style0 from "./BarOrderPanel.vue?vue&type=style&index=0&id=6b7f7efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7f7efe",
  null
  
)

export default component.exports